import { render, staticRenderFns } from "./top-notice.vue?vue&type=template&id=31ce160e&scoped=true"
import script from "./top-notice.vue?vue&type=script&lang=js"
export * from "./top-notice.vue?vue&type=script&lang=js"
import style0 from "./top-notice.vue?vue&type=style&index=0&id=31ce160e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ce160e",
  null
  
)

export default component.exports